
import {zip} from '../utils.js';
import FieldContour from "./FieldContour.js";
import FieldContourFill from "./FieldContourFill.js";
import FieldBarbs from "./FieldBarbs.js";
import FieldHodographs from './FieldHodographs.js';

function aggregateFields(func, ...args) {
    const arg_data = [...zip(...args.map(a => a['data']))];
    const agg_data = new Float32Array(arg_data.map(a => func(...a)));
    return {...args[0], ...{'data': agg_data}};
}

export {aggregateFields, 
        FieldContourFill, FieldContour, FieldBarbs, FieldHodographs};